exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ReservationsTable table {\n  font-size: 14px;\n}\n.ReservationsTable tr th {\n  text-align: left;\n}\n.ReservationsTable tr td {\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/admin/components/tables/ReservationsTable.less
// module id = 1343
// module chunks = 0